

export type StaleTone = 'match' | 'stale' | 'unknown'

/** Compare a plan's prior_serial to the workspace's current state serial. */
export function staleness(priorSerial: number | null, currentSerial: number | null | undefined): { tone: StaleTone; label: string } {
  if (priorSerial == null || currentSerial == null) return { tone: 'unknown', label: 'staleness unknown' }
  if (priorSerial === currentSerial) return { tone: 'match', label: `fresh · serial ${currentSerial}` }
  return { tone: 'stale', label: `stale · plan@${priorSerial} vs state@${currentSerial}` }
}

export const STALE_STYLE: Record<StaleTone, { color: string; border: string }> = {
  match:   { color: 'var(--green)', border: 'var(--green)' },
  stale:   { color: 'var(--amber)', border: 'var(--amber)' },
  unknown: { color: 'var(--text3)', border: 'var(--border)' },
}

